import api from './api'
import {
  AdminReviewListResponse,
  PaginationParams
} from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

type ReviewSortField =
  | 'createdAt'
  | 'customerName'
  | 'productName'
  | 'rating'
  | 'status'
  | 'helpfulVotes'

const adminReviewService = {
  async list(params?: {
    search?: string
    status?: 'pending' | 'approved' | 'rejected'
    sortBy?: ReviewSortField
    sortOrder?: 'asc' | 'desc'
  } & PaginationParams): Promise<AdminReviewListResponse> {
    const response = await api.get<
      ApiSuccessResponse<AdminReviewListResponse>
    >('/admin/reviews', {
      params
    })

    return response.data.data
  },

  async approve(reviewId: string): Promise<void> {
    await api.post<ApiSuccessResponse<unknown>>(
      `/admin/reviews/${reviewId}/approve`
    )
  },

  async reject(reviewId: string): Promise<void> {
    await api.post<ApiSuccessResponse<unknown>>(
      `/admin/reviews/${reviewId}/reject`
    )
  },

  async remove(reviewId: string): Promise<void> {
    await api.delete(`/admin/reviews/${reviewId}`)
  }
}

export default adminReviewService


